import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M9.362 20.628a2.625 2.625 0 1 0 5.25 0 2.625 2.625 0 1 0-5.25 0m0-17.25a2.625 2.625 0 1 0 5.25 0 2.625 2.625 0 1 0-5.25 0m0 8.625a2.625 2.625 0 1 0 5.25 0 2.625 2.625 0 1 0-5.25 0"
    }, null, -1)
  ]));
}
const interfaceDotsVertical = { render };
export {
  interfaceDotsVertical as default,
  render
};
//# sourceMappingURL=interface-dots-vertical.svg.js.map
